import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import { EmailsTemplateFormVM } from '../emails-template-form.viewmodel';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../../../global/rich-text-editor';
import { configForGoogleCalendar } from '../../../../../../global/rich-text-editor/CKEditor.config';
import { EmailTemplateType } from '../../../../../../../api/email-configuration.dao';
import './emails-template-form-body.scss';


interface IProps {
    vm: EmailsTemplateFormVM;
}

const EmailTemplatesFormBody = observer((props: IProps) => {
    const { vm } = props;
    const { type } = vm.selectedEmailTemplate;
    const isTemplateCalendarInvitation = type === EmailTemplateType.REGISTRATION_CALENDAR_INVITATION
        || type === EmailTemplateType.MEETING_CALENDAR_INVITATION
        || type === EmailTemplateType.BOOKABLE_MEETING_CALENDAR_INVITATION
        || type === EmailTemplateType.PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION;
    const subjectLabel = isTemplateCalendarInvitation
        ? <FormattedMessage
            id='oe.label.invitationSubject'
            description='Label text'
            defaultMessage='Invitation Subject'
        />
        : <FormattedMessage
            id='oe.label.emailSubject'
            description='Label text'
            defaultMessage='Email Subject'
        />
    ;
    const bodyLabel = isTemplateCalendarInvitation
        ? <FormattedMessage
            id='oe.label.invitationBody'
            description='Label text'
            defaultMessage='Invitation Body'
        />
        : <FormattedMessage
            id='oe.label.emailBody'
            description='Label text'
            defaultMessage='Email Body'
        />
    ;

    return (
        <div className='emails-template-form__content'>
            <FormField
                className='m-top-5px'
                label={subjectLabel}
                labelFor='emails-template-subject'
            >
                <div className='flex'>
                    <input
                        id='emails-template-subject'
                        className='oe-form-field__control'
                        value={vm.getSelectedTemplateSubject ?? ''}
                        onChange={e => vm.setEmailSubject(e.target.value)}
                        type='text'
                    />
                </div>
                {!!vm.getSelectedTemplateSubjectError
                && <span className='oe-form-field__error'>{vm.getSelectedTemplateSubjectError}</span>
                }
            </FormField>
            <FormField
                label={bodyLabel}
                className='with-editor'
            >
                <RichTextEditor
                    className='m-top-0px body-editor'
                    value={vm.getSelectedTemplateBody ?? ''}
                    onChange={action((event, editor) => {
                    vm.setEmailBody(editor.getData());
                    })}
                    validationError={vm.emailTemplatesErrorHandler[`${vm.currentTemplate}`]?.emailBodyError ?? null}
                    config={isTemplateCalendarInvitation ? configForGoogleCalendar : undefined}
                />
            </FormField>
            {isTemplateCalendarInvitation &&
            <FormField
                className='m-top-5px'
                label={<FormattedMessage
                    id='oe.label.location'
                    description='Label text'
                    defaultMessage='Location'
                />}
                labelFor='emails-template-location'
            >
                <div className='flex'>
                    <input
                        id='emails-template-location'
                        className='oe-form-field__control'
                        value={vm.getSelectedTemplateLocation ?? ''}
                        onChange={e => vm.setTemplateEmailLocation(e.target.value)}
                        type='text'
                    />
                </div>
                {vm.getSelectedTemplateLocationError
                && <span className='oe-form-field__error'>{vm.getSelectedTemplateLocationError}</span>
                }
            </FormField>
            }
        </div>
    );
});

export default EmailTemplatesFormBody;
